import create from 'zustand';

interface StudentSeatUpdate {
  readingLevel?: string | null;
  readingLevelAEnabled?: boolean;
  studentSeatId: string;
}

interface StudentSeatSyncState {
  lastUpdate: StudentSeatUpdate | null;
  notify: (update: StudentSeatUpdate) => void;
}

const useStudentSeatSyncStore = create<StudentSeatSyncState>(set => ({
  lastUpdate: null,
  notify: (update) => set({ lastUpdate: update }),
}));

export default useStudentSeatSyncStore;
